import * as React from "react";
function SvgUserOff(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={24}
        cy={24}
        r={5}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M21 27l6-6"
      />
      <circle
        cx={14}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M9.11 29H3a11 11 0 0118-8.48"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserOff);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
